import { Document, Page, View } from '@react-pdf/renderer'

import { PdfPageCounter } from '@features/exports/elements/PdfPageCounter/PdfPageCounter'
import { pagePdfStyles } from '@features/exports/utils/pagePdfStyles'
import { VatDeclarationsPeriod } from '@features/vatDeclarations/types/vatDeclarationsPeriod'

import { AuditTrailPdf } from '../../AuditTrail/elements/AuditTrailExport/AuditTrailPdf'
import { AuditTrailAccountTable } from '../../AuditTrail/types/AuditTrail'
import { ExportHeaderPdf } from './elements/ExportHeaderPdf'
import { ExportTablePdf } from './elements/ExportTablePdf'

interface VatDeclarationExportPdfProps {
  auditTrailData: AuditTrailAccountTable[]
  countryId?: string
  currency?: string
  data: VatDeclarationsPeriod
  locale?: string
  organizationName?: string
  withAuditTrail?: boolean
}

export const VatDeclarationExportPdf = ({
  auditTrailData,
  data,
  organizationName,
  withAuditTrail,
  countryId,
  locale,
  currency,
}: VatDeclarationExportPdfProps) => {
  const { report, periodText } = data
  const showAuditTrail = withAuditTrail && auditTrailData && auditTrailData.length > 0

  return (
    <Document>
      <Page size="A4" wrap orientation="portrait" style={pagePdfStyles.page}>
        <View>
          <ExportHeaderPdf locale={locale} organizationName={organizationName} periodText={periodText} />
          <ExportTablePdf report={report} countryId={countryId} locale={locale} currency={currency} />
        </View>

        {showAuditTrail && (
          <View>
            <AuditTrailPdf data={auditTrailData} />
          </View>
        )}
        <PdfPageCounter />
      </Page>
    </Document>
  )
}
